(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["new-batch-component"] && !Shopify.designMode) return;
  try {
    (function() {
  const START_YEAR = 2026;
  const START_MONTH = 0;
  const START_DAY = 4;
  const BATCH_INTERVAL = 15;
  const ONE_DAY_MS = 24 * 60 * 60 * 1000;
  
  function createLocalDate(year, month, day) {
    return new Date(year, month, day, 0, 0, 0, 0);
  }
  
  const START_DATE_NORMALIZED = createLocalDate(START_YEAR, START_MONTH, START_DAY);
  
  function normalizeDateToMidnight(date) {
    const normalized = new Date(date);
    normalized.setHours(0, 0, 0, 0);
    return normalized;
  }
  
  function getDaysBetween(date1, date2) {
    const d1 = normalizeDateToMidnight(date1);
    const d2 = normalizeDateToMidnight(date2);
    const diff = d2.getTime() - d1.getTime();
    return Math.floor(diff / ONE_DAY_MS);
  }
  
  function createBatchDate(batchNum) {
    const daysToAdd = batchNum * BATCH_INTERVAL;
    const resultDate = createLocalDate(START_YEAR, START_MONTH, START_DAY + daysToAdd);
    return resultDate;
  }
  
  function getBatchDates(currentDate) {
    const daysSinceStart = getDaysBetween(START_DATE_NORMALIZED, currentDate);
    const batchNumber = Math.floor(daysSinceStart / BATCH_INTERVAL);
    const daysIntoCurrentBatch = daysSinceStart % BATCH_INTERVAL;
    
    let prevBatchNum, currentBatchNum, nextBatchNum, daysUntilNext;
    
    if (daysIntoCurrentBatch === 0) {
      prevBatchNum = batchNumber - 1;
      currentBatchNum = batchNumber;
      nextBatchNum = batchNumber + 1;
      daysUntilNext = 0;
    } else if (daysIntoCurrentBatch === 1) {
      prevBatchNum = batchNumber;
      currentBatchNum = batchNumber + 1;
      nextBatchNum = batchNumber + 2;
      daysUntilNext = BATCH_INTERVAL;
    } else {
      prevBatchNum = batchNumber;
      currentBatchNum = batchNumber + 1;
      nextBatchNum = batchNumber + 2;
      daysUntilNext = BATCH_INTERVAL - daysIntoCurrentBatch;
    }
    
    const prevDate = createBatchDate(prevBatchNum);
    const currentDateObj = createBatchDate(currentBatchNum);
    const nextDate = createBatchDate(nextBatchNum);
    
    return { prevDate, currentDateObj, nextDate, daysUntilNext };
  }
  
  function formatDate(date, uppercase = true) {
    const months = ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December'];
    const day = date.getDate();
    const suffix = day === 1 || day === 21 || day === 31 ? 'st' : day === 2 || day === 22 ? 'nd' : day === 3 || day === 23 ? 'rd' : 'th';
    const month = uppercase ? months[date.getMonth()].toUpperCase() : months[date.getMonth()];
    const suffixFormatted = uppercase ? suffix.toUpperCase() : suffix;
    return `${month} ${day}${suffixFormatted}`;
  }
  
  function getPercentage(daysLeft) {
    if (daysLeft === 0) return 97;
    if (daysLeft >= 13) return 57;
    if (daysLeft <= 4) return 97;
    return Math.round(47 + (50 * (13 - daysLeft) / 9));
  }
  
  const section = document.querySelector('[data-animate-progress="true"]');
  if (!section) return;
  
  const fill = section.querySelector('.next-batch-bar__fill--active');
  const percentageEl = section.querySelector('.next-batch-bar__percentage');
  let hasAnimated = false;
  let currentTargetWidth = 0;
  
  function updateComponent() {
    const now = new Date();
    now.setHours(0, 0, 0, 0);
    const { prevDate, currentDateObj, nextDate, daysUntilNext } = getBatchDates(now);
    
    const countdownEl = document.querySelector('[data-countdown]');
    const shipDateEl = document.querySelector('[data-ship-date]');
    const prevDateEl = document.querySelector('[data-prev-date]');
    const currentDateEl = document.querySelector('[data-current-date]');
    const nextDateEl = document.querySelector('[data-next-date]');
    
    if (countdownEl) {
      if (daysUntilNext === 0) {
        countdownEl.textContent = 'TODAY';
      } else if (daysUntilNext === 1) {
        countdownEl.textContent = '1 DAY';
      } else {
        countdownEl.textContent = `${daysUntilNext} DAYS`;
      }
    }
    
    if (shipDateEl) shipDateEl.textContent = formatDate(currentDateObj, false);
    if (prevDateEl) prevDateEl.textContent = formatDate(prevDate);
    if (currentDateEl) currentDateEl.textContent = formatDate(currentDateObj);
    if (nextDateEl) nextDateEl.textContent = formatDate(nextDate);
    
    const percentage = 97 || getPercentage(daysUntilNext);
    currentTargetWidth = percentage;
    if (fill) fill.dataset.targetWidth = percentage;
    if (percentageEl && !hasAnimated) percentageEl.textContent = percentage;
  }
  
  function animateProgress() {
    if (hasAnimated) return;
    hasAnimated = true;
    
    const targetWidth = currentTargetWidth || parseInt(fill.dataset.targetWidth) || 97;
    fill.style.width = targetWidth + '%';
    
    let currentPercent = 0;
    const duration = 1500;
    const startTime = performance.now();
    
    function updatePercentage(currentTime) {
      const elapsed = currentTime - startTime;
      const progress = Math.min(elapsed / duration, 1);
      const easeOut = 1 - Math.pow(1 - progress, 3);
      currentPercent = Math.round(easeOut * targetWidth);
      percentageEl.textContent = currentPercent;
      if (progress < 1) {
        requestAnimationFrame(updatePercentage);
      }
    }
    
    requestAnimationFrame(updatePercentage);
  }
  
  updateComponent();
  
  const observer = new IntersectionObserver((entries) => {
    for (const entry of entries) {
      if (entry.isIntersecting) {
        animateProgress();
        observer.disconnect();
      }
    }
  }, { threshold: 0.5 });
  
  observer.observe(section);
  
  setInterval(() => {
    updateComponent();
    if (hasAnimated && fill) {
      fill.style.width = currentTargetWidth + '%';
      if (percentageEl) percentageEl.textContent = currentTargetWidth;
    }
  }, 60000);
})();
  } catch(e) { console.error(e); }
})();

})();
